import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        products: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        set(state, products) {
            state.products = products;
        }
    },

    actions: {
        load({commit}, id) {
            commit('setLoading', true);

            return HTTP.get('/products/' + id)
                .then(resp => {
                    commit('setLoading', false);
                    commit('set', resp.data);
                    return resp.data;
                });
        },

        save({commit, state}, product) {
            commit('setLoading', true);

            if(product.categories !== undefined && product.categories !== null) {
                product.categories = product.categories.map(c => c.id);
            }

            if(product.id === undefined) {
                return HTTP.post('/products', product)
                    .then(() => commit('setLoading', false))
                    .catch(err => commit('error/set', err.response.data, { root: true }));
            } else if (product.id !== undefined) {
                return HTTP.post('/products/' + product.id, product)
                    .then(() => commit('setLoading', false))
                    .catch(err => commit('error/set', err.response.data, { root: true }));
            }
        },

        delete({ commit, state }) {
            return HTTP.delete('/admin/products/' + state.product.id)
                .catch(err => commit('error/set', err.response.data, { root: true }));
        },

        loadAll({ commit }) {

            return HTTP.get('/products')
                .then(resp => commit('set', resp.data))
                .catch(err => commit('error/set', err.response, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/admin-product.js